module.exports = __webpack_public_path__ + "assets/fe856060420be3e66b37ee99669d1d7f.png";